import axios from 'axios';
import globals from "../config/appconfig";

export default class MalattieService {

    static urlMalattie = globals["app-url-backend-malattie"]

    // static urlFocolai = "http://localhost:8085/api/v1/ricercafocolaio" //mockup per run locale

    static getInfoCliniche(param) {
        let querystring = "/malattie/";

        querystring = querystring.concat(param).concat("/infocliniche");

        return axios.get(this.urlMalattie + querystring)
    }

    static getInfoEpidemiologiche(param) {
        let querystring = "/malattie/";

        querystring = querystring.concat(param).concat("/infoepidemiologiche");

        return axios.get(this.urlMalattie + querystring)
    }

    static getInfoLaboratorio(param) {
        let querystring = "/malattie/";

        querystring = querystring.concat(param).concat("/infolaboratorio");

        return axios.get(this.urlMalattie + querystring)
    }

    static getEsiti(param) {
        let querystring = "/malattie/";

        querystring = querystring.concat(param).concat("/esiti");

        return axios.get(this.urlMalattie + querystring)
    }


    static getSezioni(param) {
        let querystring = "/malattie/"

        querystring = querystring.concat(param).concat("/sezionidatispecifici");

        return axios.get(this.urlMalattie + querystring);
    }

    static getPrimaLocalizzazione(param) {
        let querystring = "/malattie/"

        querystring = querystring.concat(param).concat("/primalocalizzazione");

        return axios.get(this.urlMalattie + querystring);
    }

    static getAltraLocalizzazione(param) {
        let querystring = "/malattie/"

        querystring = querystring.concat(param).concat("/altrelocalizzazioni");

        return axios.get(this.urlMalattie + querystring);
    }


    static getContatti(param) {
        let querystring = "/malattie/";

        querystring = querystring.concat(param).concat("/contatti");

        return axios.get(this.urlMalattie + querystring)
    }

    static getTrasmissioni(param) {
        let querystring = "/malattie/";

        querystring = querystring.concat(param).concat("/trasmissioni");

        return axios.get(this.urlMalattie + querystring)
    }

    static getTerapie(param) {
        let querystring = "/malattie/"

        querystring = querystring.concat(param).concat("/terapie");

        return axios.get(this.urlMalattie + querystring);
    }

    static getFarmacoresistenza(param) {
        let querystring = "/malattie/"

        querystring = querystring.concat(param).concat("/farmacoresistenza");

        return axios.get(this.urlMalattie + querystring);
    }

    static getGeni(param, tipo) {
        let querystring = "/malattie/";

        querystring = querystring.concat(param).concat("/geni?tipoConferma=").concat(tipo);

        return axios.get(this.urlMalattie + querystring)
    }

    static getLivelloResistenze(param) {
        let querystring = "/malattie/"

        querystring = querystring.concat(param).concat("/livelloresistenza");

        return axios.get(this.urlMalattie + querystring);
    }

    static getEnzimiProdotti(param) {
        let querystring = "/malattie/"

        querystring = querystring.concat(param).concat("/enzimiprodotti");

        return axios.get(this.urlMalattie + querystring);
    }

    static getTipologiaVeicolo(param) {
        let querystring = "/malattie/"

        querystring = querystring.concat(param).concat("/tipologiaveicoli");

        return axios.get(this.urlMalattie + querystring);
    }

    static getVeicoloPerTipoVeicolo(param, tipoVeicolo) {
        let querystring = "/malattie/"

        querystring = querystring.concat(param).concat("/veicolo") + "?tipoVeicolo=" + tipoVeicolo;

        return axios.get(this.urlMalattie + querystring);
    }

    static getInfoMalattia(param) {
        let querystring = "/malattie/"

        querystring = querystring.concat(param).concat("/informazioni");

        return axios.get(this.urlMalattie + querystring);
    }

    static getListaFarmaci() {

        return axios.get(this.urlMalattie + "/malattie/farmaci");
    }




}
